import { useDispatch } from "react-redux";
import { ne1updateAssessmentNewMeasurementAsync } from "../../../../../app/patientSlice";
import { toLocalISOWithOffset } from "../../../../../utils";

export const useMeasurementTracing = ({
  patientId,
  assessmentId,
  assessmentDetail,
  measurementData,
  woundType,
  setHeadToToeView,
  setAnnotationView,
  setMeasurementModal,
  setPendingTimer,
  setPendingRetires,
}) => {
  const dispatch = useDispatch();

  const createTracingPayload = () => {
    return {
      patient_id: patientId,
      assessment_id: assessmentId,
      wound_type: assessmentDetail?.isWoundWithoutPhoto === 1 ? "new_wound" : "existing_wound",
      blob_info: null,
      blob_image: measurementData?.intialImageSASURL,
      base64_image: null,
      camera_meta_data: null,
      device_details: null,
      woundModifiedDate: toLocalISOWithOffset(new Date()),
    };
  };

  const handleTrace = (common, dots) => {
    setHeadToToeView(false);
    const basePayload = createTracingPayload();
    const tracingPayload = {
      ...basePayload,
      idempotency_key: crypto.randomUUID(),
      common: {
        arrow_to_head: common?.arrow_to_head,
        arrow_to_toe: common?.arrow_to_toe,
        total_detections: {
          marker: 0,
        },
        image_type: "primary",
        user_selected_trace: false,
      },
      wound_trace: dots,
      replay_wound: woundType,
    };
    dispatch(ne1updateAssessmentNewMeasurementAsync(tracingPayload));
    setPendingTimer(5000);
    setMeasurementModal(false);
    setPendingRetires(0);
  };

  const evalWound = (annotation) => {
    setAnnotationView(false);
    const { regions, pixelSize } = annotation.images[0];
    const pixelPoints = regions?.map((data) =>
      data?.points?.map(([x, y]) => ({
        x: x * pixelSize?.w,
        y: y * pixelSize?.h,
      }))
    );
    const basePayload = createTracingPayload();
    const newWoundPayload = {
      ...basePayload,
      common: {
        image_type: "primary",
        user_selected_trace: true,
        arrow_to_toe: null,
        arrow_to_head: null,
        total_detections: {
          marker: 0,
        },
      },
      wound_trace: pixelPoints,
    };
    dispatch(ne1updateAssessmentNewMeasurementAsync(newWoundPayload));
    setPendingTimer(5000);
    setMeasurementModal(false);
    setPendingRetires(0);
  };

  return { handleTrace, evalWound };
};
